module.exports = __webpack_public_path__ + "static/media/matilde-hat-greece-happy.baffa5b6.png";